import React, { PureComponent } from "react";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import styles from "./select.module.scss";
import dataProvider, { GET_LIST } from "providers/dataProvider";
import FormHelperText from "@mui/material/FormHelperText";

class SelectField extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      options: [],
    };
  }

  componentDidMount() {
    const { input } = this.props;
    this.initOption(input);
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      JSON.stringify(prevProps.input.options) !==
      JSON.stringify(this.props.input.options)
    ) {
      this.setState({
        options: this.props.input.options,
      });
    }
  }

  initOption = (input) => {
    if (input.hasOwnProperty("resource")) {
      this.loadOptions();
    } else if (input.hasOwnProperty("options")) {
      this.setState({
        options: input.options,
      });
    }
  };

  getFilter = (input) => {
    try {
      return (
        input.filter ||
        (input.relativeInputsFilterAccessor &&
          input.relativeInputsFilterAccessor(input.relativeInputsData)) ||
        {}
      );
    } catch {
      return false;
    }
  };

  getResource = (input, options) => {
    try {
      return (
        input.resource ||
        (input.resourceAccessor && input.resourceAccessor(options)) ||
        input.relativeInputResourceAccessor(input.relativeInputsData)
      );
    } catch {
      return false;
    }
  };

  loadOptions() {
    const { input, options } = this.props;
    const filter = this.getFilter(input);
    const resource = this.getResource(input, options);

    if (!filter) return;
    if (!resource) return;

    dataProvider(GET_LIST, resource, { filter })
      .then(({ data, total }) => {
        let options = data && Array.isArray(data) && input.accessor ? data.map(input.accessor) : [];
        this.setState({
          options,
        });
      })
      .catch((error) => {
        console.error("Error loading select options:", error);
        this.setState({
          options: [],
        });
      });
  }

  onKeyPress = (e) => {
    const { inputId, handleInputs } = this.props;
    const option = this.state.options.filter(
      (item) => item.shortKeyCode === e.key
    )[0];

    if (!option) return;

    handleInputs({
      target: {
        value: option.value,
        name: inputId,
      },
    });
  };

  render() {
    const {
      input,
      inputId,
      style,
      handleInputs,
      value,
      disabled,
      selectStyles,
    } = this.props;
    const renderStyles = selectStyles ? selectStyles : styles;
    const { options } = this.state;
    
    let required = input.hasOwnProperty('yup');
    
    if (input.hasOwnProperty('required')) {
      required = input.required;
    }
    
    return (
      <FormControl 
        variant="standard" 
        sx={{ 
          // m: 1, 
          // minWidth: 120,
          "& .MuiInputLabel-root.Mui-focused": {
            color: "#004C6A",
          },
          "& .MuiInputBase-root": {
       },
          "& .MuiInput-underline:before": {
            borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottom: "2px solid rgba(0, 0, 0, 0.87)",
          },
          "& .MuiInput-underline:after": {
            borderBottomColor: "#004C6A",
          },
        }} 
        className={style.textField} 
        disabled={disabled} 
        error={input.error} 
        required={required}
      >
        <InputLabel htmlFor="age-simple">{input.label}</InputLabel>
        {options.length > 0 && (
          <React.Fragment>
            <Select
              onKeyPress={this.onKeyPress}
              error={input.error}
              value={value === null ? "" : value}
              onChange={handleInputs}
              name={inputId}
              inputProps={{ "aria-label": "Without label" }}
              className={renderStyles.field}
              sx={{
                '& .MuiSelect-select': {
                  fontSize: '13.7143px',
                  padding: '6px 0 7px',
                },
                '& .MuiSelect-icon': {
                  fontSize: '1.2857142857142856rem',
                },
                '& .MuiNativeSelect-icon': {
                  fontSize: '1.2857142857142856rem',
                },
              }}
              
                     >
              {options.map((option, key) => (
                <MenuItem key={key} value={option.value} style={{ fontSize: '13.7143px' }}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
            {input.error && input.errorMessage && <FormHelperText>{input.error && input.errorMessage}</FormHelperText>}
          </React.Fragment>
        )}
      </FormControl>
    );
  }
}

SelectField.defaultProps = {
  style: {
    textField: "",
  },
};

export default SelectField;
